export default __webpack_public_path__ + "static/media/AdhesivesImg.c4b5f040.jpg";